/**
 * Allow to extract keys of a given object to an array
 * Only present keys can be set
 *
 * Notice: do not handle nested properties
 */
export function defineKeys<T>(){
  return <K extends readonly (keyof T)[]>(keys:K)=> keys
}